import { schema } from 'normalizr';

export const name = 'teamRosters';
export const teamRosterSchema = new schema.Entity(name);
export const teamRostersCollectionSchema = new schema.Array(teamRosterSchema);
